export default "__VITE_ASSET__7f7efdd1__"